import React from 'react';

import { RFValue } from 'react-native-responsive-fontsize';

import { Button } from '../../components/Interface/Forms/Buttons/Button';

import { StepList } from '../../components/Interface/List/StepList';

import {
  Container,
  Content,
  Footer,
  List,
  Section,
  SectionHeader,
  SectionTitle,
  TitlesContainer,
} from './styles';
import { Header } from '../../components/Interface/Headers/Header';
import { Titles } from '../../components/Interface/Typographies/Titles';
import { Linking } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

export function Vigilante() {
  function handleVigilante() {
    Linking.openURL(
      'https://api.whatsapp.com/send/?phone=5561998202004&text=Ol%C3%A1%2C%20quero%20ajudar%20a%20manter%20os%20pre%C3%A7os%20baixo&type=phone_number&app_absent=0',
    );
  }

  return (
    <Container>
      <Header icon="chevron-left" />
      <TitlesContainer>
        <Titles
          title="Vigilante do preço"
          subtitle="Precisamos manter os preços baixos. Nos infome quais os valores na sua região."
        />
      </TitlesContainer>
      <Content>
        <Section
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{ paddingBottom: RFValue(20) }}>
          <SectionHeader>
            <SectionTitle>Como funciona:</SectionTitle>
          </SectionHeader>

          <List>
            <StepList
              number={1}
              text='Clique no botão "Quero ajudar!" ao final da tela.'
            />
            <StepList
              number={2}
              text='Envie uma mensagem no chat, aguarde a resposta, selecione a opção "Outros assuntos" e em seguida "Falar com atendente" e aguarde um especialista iniciar seu atendimento.'
            />

            <StepList
              number={3}
              text="Tire uma foto da placa com os preços do posto e envie ao nosso especialista."
            />
            <StepList
              number={4}
              text="Pronto! Sua solicitação foi registrada e o nosso time irá analisa-lá cuidadosamente."
            />
          </List>
        </Section>
      </Content>

      <Footer>
        <SafeAreaView>
          <Button title="Quero ajudar" onPress={handleVigilante} enabled />
        </SafeAreaView>
      </Footer>
    </Container>
  );
}
